import React from 'react';
import { Button, CircularProgress, FormHelperText, Stack, Tooltip } from '@mui/material';
import { useFormikContext } from 'formik';
import { FolioDrawerFooter } from '@/components/Drawers/FolioDrawer/FolioDrawerFooter';
import { useUnlayerDraftContext } from '@/context/UnlayerDraftContext';
import { useUnlayerTemplateContext } from '@/context/UnlayerTemplateContext';
import { useUnlayerComposeInteractionsContext } from '@/context/UnlayerComposeInteractionsContext';
import { useUnlayerSendContext } from '@/context/UnlayerSendContext';

/**
 * Renders the compose footer actions for saving drafts/templates and confirming send.
 */
export const ComposeFooterActions = () => {
	const { sendError } = useUnlayerSendContext();
	const { canUseDraftContext, createDraft, isAnyDraftActionLoading } = useUnlayerDraftContext();
	const { isSavingTemplate, openSaveTemplateDialog } = useUnlayerTemplateContext();
	const { handleValidateAndOpenSendDialog } = useUnlayerComposeInteractionsContext();
	const { isSubmitting, values } = useFormikContext();

	const disabledCreateDraft =
		isSubmitting ||
		isAnyDraftActionLoading ||
		!canUseDraftContext ||
		values.subject.trim().length === 0;
	const createDraftTooltip = !canUseDraftContext
		? 'Select a client or deal to save a draft.'
		: values.subject.trim().length === 0
			? 'Subject is required.'
			: '';
	const disabledCreateTemplate = isSubmitting || isSavingTemplate;
	const createTemplateTooltip = isSavingTemplate ? 'Saving template...' : '';

	return (
		<FolioDrawerFooter>
			<Stack spacing={1} sx={{ width: '100%' }}>
				{sendError.length > 0 && <FormHelperText error>{sendError}</FormHelperText>}
				<Stack
					direction={{ xs: 'column', md: 'row' }}
					alignItems={{ xs: 'stretch', md: 'center' }}
					justifyContent='center'
					spacing={1}
				>
					<Tooltip title={createDraftTooltip}>
						<span>
							<Button
								variant='outlined'
								disabled={disabledCreateDraft}
								onClick={createDraft}
							>
								SAVE AS DRAFT
							</Button>
						</span>
					</Tooltip>
					<Tooltip
						title={createTemplateTooltip}
						disableHoverListener={createTemplateTooltip.length === 0}
					>
						<span>
							<Button
								variant='outlined'
								disabled={disabledCreateTemplate}
								onClick={() =>
									openSaveTemplateDialog(values.subject.trim() || 'Untitled Template')
								}
							>
								{isSavingTemplate ? (
									<CircularProgress size='1.5em' />
								) : (
									'SAVE AS TEMPLATE'
								)}
							</Button>
						</span>
					</Tooltip>
					<Button
						variant='contained'
						disabled={isSubmitting}
						onClick={handleValidateAndOpenSendDialog}
					>
						{isSubmitting ? (
							<CircularProgress size='1.5em' sx={{ color: '#ffffff' }} />
						) : (
							'Send Email'
						)}
					</Button>
				</Stack>
			</Stack>
		</FolioDrawerFooter>
	);
};
